import { useTranslation } from 'react-i18next'
import { Select as AntSelect, Spin } from 'antd'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { IRole } from 'interfaces/roles'
import EmptyState from 'components/reusables/emptyState'
import Select from 'components/reusables/select'
import { AvatarWithInfo } from 'components/reusables/avatarWithInfo/AvatarWithInfo'
import { useRolesAndPermissions } from '../../../context/RolesAndPermissionsContext'
import { Wrapper, Subtitle, OptionWrapper } from './styled'

const { Option } = AntSelect

interface IProps {
  selectedRole: IRole | undefined
  setSelectedRole: (role: IRole | undefined) => void
  disabled?: boolean
}

const SelectRole = ({
  selectedRole,
  setSelectedRole,
  disabled = false,
}: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.assignRole.inputs.chooseRole'
  const { roleOptions: roles, roleOptionsLoading: loading } =
    useRolesAndPermissions()

  return (
    <Wrapper $isEmpty={selectedRole === undefined}>
      <Subtitle>{t(`${prefix}.title`)}</Subtitle>
      <Spin spinning={loading}>
        <Select
          showSearch={true}
          value={selectedRole?.id}
          placeholder={t(`${prefix}.placeholder`)}
          disabled={disabled}
          onSelect={(value) =>
            setSelectedRole(roles.find((role) => role.id === value))
          }
          notFoundContent={
            <EmptyState title={t(`${prefix}.emptyState`)} icon={faList} />
          }
        >
          {roles.map((item) => (
            <Option key={item.id} value={item.id} label={item.name}>
              <OptionWrapper>
                <AvatarWithInfo
                  title={item.name}
                  subtitle={item.code}
                  principalColor="#0E0E0E"
                  fontWeight="normal"
                  size={30}
                  borderRadius={8}
                />
              </OptionWrapper>
            </Option>
          ))}
        </Select>
      </Spin>
    </Wrapper>
  )
}

export default SelectRole
